
import React from "react";
import DefaultOpportunityCard from "./DefaultOpportunityCard";
import CompactOpportunityCard from "./CompactOpportunityCard";
import type { DevTool } from "@/components/dashboard/roadmap/DevToolSelect";

interface OpportunityCardProps {
  opportunity: any;
  variant?: 'default' | 'compact';
  number?: number;
  cardId?: string;
  devTool?: DevTool;
}

const OpportunityCard = ({ 
  opportunity,
  variant = 'default',
  number,
  cardId,
  devTool = "jira"
}: OpportunityCardProps) => {

  if (variant === 'compact') {
    return (
      <CompactOpportunityCard
        opportunity={opportunity}
        number={number}
        cardId={cardId}
        devTool={devTool}
      />
    );
  }

  return (
    <DefaultOpportunityCard
      opportunity={opportunity}
      number={number}
      cardId={cardId}
      devTool={devTool}
    />
  );
};

export default OpportunityCard;
